import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { ServerProvider } from '../../providers/server/server';
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { PeriodicityFormatterProvider } from '../../providers/periodicity-formatter/periodicity-formatter';
import {PeriodicTransactionAddPage, PERIODIC_TRANSACTION_CREATED_EVENT} from '../periodic-transaction-form/periodic-transaction-form-add';
import {PeriodicTransactionEditPage, PERIODIC_TRANSACTION_UPDATED_EVENT} from '../periodic-transaction-form/periodic-transaction-form-edit';
import { Events } from 'ionic-angular';
import { PeriodicTransactionLogPage } from '../periodic-transaction-log/periodic-transaction-log';


@Component({
    selector: 'page-periodic-transaction',
    templateUrl: 'periodic-transaction.html',
})
export class PeriodicTransactionPage {
    user_id: any;
    periodic_transactions = [];

    constructor(public navCtrl: NavController, public navParams: NavParams,
        public server: ServerProvider, private alertCtrl: AlertController,
        public loadingCtrl: LoadingController, public periodicity_formatter: PeriodicityFormatterProvider,
        public modalCtrl: ModalController,public events: Events
    ) {
        this.user_id = JSON.parse(window.localStorage['account'])["currentUser"]["id"];



        events.subscribe(PERIODIC_TRANSACTION_CREATED_EVENT, (periodic_transaction)=>{
            this.periodic_transactions.push(periodic_transaction)
        })

        events.subscribe(PERIODIC_TRANSACTION_UPDATED_EVENT, (periodic_transaction)=>{
            this.fetch()
        })

        this.fetch()
    }

    fetch(){
        let loader = this.loadingCtrl.create({
            content: "Bitte warten",
            duration: 5000
        });
        loader.present()
        this.server.getPeriodicTransactions(this.user_id).subscribe(
            data => {
                this.periodic_transactions = data.json()
                loader.dismiss()
            },
            error => {
                loader.dismiss()
            }
        )
    }

    goto_periodic_transaction_log(){
        console.log("Clicked goto periodic transaction log")
        this.navCtrl.push(PeriodicTransactionLogPage, {"user_id": this.user_id});
    }

    new_periodic_transaction() {
        let modal = this.modalCtrl.create(PeriodicTransactionAddPage, {"user_id":this.user_id});
        modal.present();
    }

    edit_periodic_transaction(idx, periodic_transaction, slidingItem) {
        let modal = this.modalCtrl.create(PeriodicTransactionEditPage, {"user_id":this.user_id, "periodic_transaction": periodic_transaction});
        modal.present();
    }

    delete_periodic_transaction(idx, periodic_transaction, slidingItem) {
        let confirm = this.alertCtrl.create({
            title: 'Dauerauftrag wirklich löschen?',
            message: 'Sind Sie sicher, dass Sie den gewählten Dauerauftrag löschen möchten?',
            buttons: [
                {
                    text: 'Abbrechen',
                    handler: () => {
                        console.log('Disagree clicked');
                    }
                },
                {
                    text: 'Löschen',
                    handler: () => {
                        console.log('Agree clicked');
                        this.server.deletePeriodicTransaction(this.user_id, periodic_transaction.account_id, periodic_transaction.id).subscribe(
                            data=>{
                                this.periodic_transactions.splice(idx, 1)
                            },
                            error=>{

                            }
                        )
                    }
                }
            ]
        });
        confirm.present();
    }

    fmt_periodicity(periodic_transaction) {
        return this.periodicity_formatter.format(periodic_transaction)
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad PeriodicTransactionPage');
    }

}



// WEBPACK FOOTER //
// ./src/pages/periodic-transaction/periodic-transaction.ts